import { configQuery, interpolate, RoutablePage, FeatureEnabledV2, MagicConfigMixin, BalanceMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { BALANCE_UPDATED, WINDOW_ROUTE_CHANGE, GAMES_XFC_CURRENCY, IS_MOBILE_APP_QUERY, MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED, BALANCE_QUERY, Feature } from '@gig/magic-messages';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';

var LAST_USED_CURRENCY = 'last-used-currency';
var DualBalance = /** @class */ (function (_super) {
    __extends(DualBalance, _super);
    function DualBalance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Currency = Currency;
        _this.animateCoinShopButton = false;
        _this.hasAnimations = false;
        _this.balance = null;
        _this.xfcBalance = null;
        _this.activeCurrency = Currency.EUR;
        _this.isTooltipOpen = false;
        _this.isMobile = false;
        _this.isDesktop = false;
        _this.isMobileApp = false;
        _this.queriedCurrency = null;
        _this.delayTimeout = null;
        _this.balanceSubscription = null;
        _this.currencySubscription = null;
        _this.videoTimeInterval = null;
        _this.videoTimeIntervalTime = 5000; // 3000ms + 2000ms animation time
        _this.dualBalancesRoutes = {};
        _this.gamesCurrencyAggregates = {};
        return _this;
    }
    DualBalance.prototype.created = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, _e, savedCurrency, initialRoute;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _d = this;
                        return [4 /*yield*/, window.queryBus.query(IS_MOBILE_APP_QUERY)];
                    case 1:
                        _d.isMobileApp =
                            (_a = (_f.sent())) !== null && _a !== void 0 ? _a : false;
                        _e = this;
                        return [4 /*yield*/, configQuery('routesForDualBalance')];
                    case 2:
                        _e.dualBalancesRoutes =
                            (_b = (_f.sent())) !== null && _b !== void 0 ? _b : {};
                        savedCurrency = this.getSavedCurrency();
                        this.activeCurrency =
                            (_c = savedCurrency !== null && savedCurrency !== void 0 ? savedCurrency : this.queriedCurrency) !== null && _c !== void 0 ? _c : Currency.EUR;
                        this.initializeCurrency();
                        return [4 /*yield*/, this.refreshBalance()];
                    case 3:
                        _f.sent();
                        initialRoute = window.location.pathname;
                        this.handleRouteChange(initialRoute);
                        this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () {
                            _this.delayTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.refreshBalance()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, _this.delay);
                        });
                        this.routeChangeSubscription = window.eventBus.subscribe(WINDOW_ROUTE_CHANGE, function (event) {
                            if (!event.payload) {
                                return;
                            }
                            _this.handleRouteChange(event.payload);
                        });
                        window.eventBus.subscribe(GAMES_XFC_CURRENCY, function (event) {
                            var aggregates = JSON.parse(JSON.stringify(event.payload));
                            if (!aggregates || Object.keys(aggregates).length === 0) {
                                return;
                            }
                            _this.onGameSelected(aggregates);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DualBalance.prototype.parseRoutePath = function (route) {
        return route.replace(/^\/[a-z]{2}(\/|$)/, '/');
    };
    Object.defineProperty(DualBalance.prototype, "getActiveCurrencyFromStorage", {
        get: function () {
            return localStorage.getItem(LAST_USED_CURRENCY);
        },
        enumerable: false,
        configurable: true
    });
    DualBalance.prototype.initializeCurrency = function () {
        var _a, _b, _c;
        var savedCurrency = this.getSavedCurrency();
        if (savedCurrency) {
            this.activeCurrency = savedCurrency;
        }
        var currentRoute = window.location.pathname;
        if (this.isOnFreeToPlayLobbyRoute(currentRoute)) {
            this.activeCurrency = Currency.XFC;
        }
        else if (this.isOnRealMoneyLobbyRoute(currentRoute)) {
            this.activeCurrency = (_a = this.queriedCurrency) !== null && _a !== void 0 ? _a : Currency.EUR;
        }
        else if (this.isOnGamePlayRoute(currentRoute) &&
            this.gamesCurrencyAggregates &&
            Object.keys(this.gamesCurrencyAggregates).length > 0) {
            this.activeCurrency = this.getCurrency(this.gamesCurrencyAggregates);
        }
        else {
            this.activeCurrency =
                (_c = (_b = this.getSavedCurrency()) !== null && _b !== void 0 ? _b : this.queriedCurrency) !== null && _c !== void 0 ? _c : Currency.EUR;
        }
        localStorage.setItem(LAST_USED_CURRENCY, this.activeCurrency);
        this.notifyMobileAppActiveCurrencyUpdate();
    };
    DualBalance.prototype.getCurrency = function (aggregates) {
        var _a;
        var isRealMoneyCurrency = function (currency) {
            return currency !== Currency.XFC;
        };
        var availableCurrencies = Object.keys(aggregates);
        if (availableCurrencies.includes(Currency.XFC)) {
            return Currency.XFC;
        }
        else {
            return ((_a = availableCurrencies.find(isRealMoneyCurrency)) !== null && _a !== void 0 ? _a : Currency.EUR);
        }
    };
    DualBalance.prototype.onGameSelected = function (aggregates) {
        this.activeCurrency = this.getCurrency(aggregates);
        localStorage.setItem(LAST_USED_CURRENCY, this.activeCurrency);
        this.notifyMobileAppActiveCurrencyUpdate();
    };
    DualBalance.prototype.isOnFreeToPlayLobbyRoute = function (route) {
        var parsed = this.parseRoutePath(route);
        return this.dualBalancesRoutes.freeToPlay.some(function (r) {
            return parsed.startsWith("/" + r);
        });
    };
    DualBalance.prototype.isOnRealMoneyLobbyRoute = function (route) {
        var _a;
        var parsed = this.parseRoutePath(route);
        return (_a = this.dualBalancesRoutes.games) === null || _a === void 0 ? void 0 : _a.some(function (r) {
            return parsed.startsWith("/" + r);
        });
    };
    DualBalance.prototype.isOnGamePlayRoute = function (route) {
        return (route.includes('/games/') || route.includes('/free-to-play-lobby/'));
    };
    DualBalance.prototype.isOnHomeRoute = function (route) {
        return this.dualBalancesRoutes.home.some(function (r) { return route === "/" + r || route === r; });
    };
    DualBalance.prototype.handleRouteChange = function (currentRoute) {
        var _a, _b;
        var isGamePlayRoute = this.isOnGamePlayRoute(currentRoute);
        if (isGamePlayRoute) {
            return;
        }
        if (this.isOnFreeToPlayLobbyRoute(currentRoute)) {
            this.activeCurrency = Currency.XFC;
        }
        else if (this.isOnRealMoneyLobbyRoute(currentRoute)) {
            this.activeCurrency = this.queriedCurrency;
        }
        else if (this.isOnGamePlayRoute(currentRoute)) {
            if (this.gamesCurrencyAggregates &&
                Object.keys(this.gamesCurrencyAggregates).length > 0) {
                this.activeCurrency = this.getCurrency(this.gamesCurrencyAggregates);
            }
            else {
                this.activeCurrency = Currency.EUR;
            }
        }
        else if (this.isOnHomeRoute(currentRoute)) {
            this.activeCurrency = (_a = this.getSavedCurrency()) !== null && _a !== void 0 ? _a : Currency.EUR;
        }
        else {
            this.activeCurrency = (_b = this.getSavedCurrency()) !== null && _b !== void 0 ? _b : Currency.EUR;
        }
        localStorage.setItem(LAST_USED_CURRENCY, this.activeCurrency);
        this.notifyMobileAppActiveCurrencyUpdate();
    };
    DualBalance.prototype.getSavedCurrency = function () {
        var saved = localStorage.getItem(LAST_USED_CURRENCY);
        return saved && Object.values(Currency).includes(saved)
            ? saved
            : null;
    };
    DualBalance.prototype.notifyMobileAppActiveCurrencyUpdate = function () {
        if (this.isMobileApp) {
            window.eventBus.publish(MOBILE_APP_BALANCE_ACTIVE_CURRENCY_UPDATED, this.activeCurrency);
        }
    };
    DualBalance.prototype.destroyed = function () {
        var _a, _b, _c;
        (_a = this.currencySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.routeChangeSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.balanceSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    };
    Object.defineProperty(DualBalance.prototype, "showIconButton", {
        get: function () {
            return this.isMobile && this.isTopNavEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualBalance.prototype, "isNotDesktop", {
        get: function () {
            return this.isMobile || !this.isDesktop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualBalance.prototype, "formattedCashBalance", {
        get: function () {
            return interpolate(this.$t('wandx.cashcoins-short'), {
                amount: this.formatIfOverLimit(this.balance.balance),
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualBalance.prototype, "formattedGoldBalance", {
        get: function () {
            return interpolate(this.$t('wandx.goldcoins-short'), {
                amount: this.formatIfOverLimit(this.xfcBalance.balance),
            });
        },
        enumerable: false,
        configurable: true
    });
    DualBalance.prototype.routeToShop = function () {
        this.routeTo({ route: RoutablePage.WALLET_DEPOSIT });
    };
    DualBalance.prototype.startVideoInterval = function () {
        var _this = this;
        this.clearVideoTimeout();
        this.videoTimeInterval = setInterval(function () {
            _this.playVideo();
        }, this.videoTimeIntervalTime);
    };
    DualBalance.prototype.clearVideoTimeout = function () {
        if (this.videoTimeInterval) {
            clearInterval(this.videoTimeInterval);
            this.videoTimeInterval = null;
        }
    };
    DualBalance.prototype.refreshBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, balance, xfcBalance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.queryBalance(this.queriedCurrency),
                            this.queryBalance(Currency.XFC),
                        ])];
                    case 1:
                        _a = _b.sent(), balance = _a[0], xfcBalance = _a[1];
                        this.balance = balance;
                        this.xfcBalance = xfcBalance;
                        return [2 /*return*/];
                }
            });
        });
    };
    DualBalance.prototype.queryBalance = function (currency) {
        return window.queryBus.query(BALANCE_QUERY, currency);
    };
    DualBalance.prototype.clearTimer = function () {
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
            this.delayTimeout = null;
        }
    };
    DualBalance.prototype.delayChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.delay === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.refreshBalance()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.clearTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    DualBalance.prototype.playVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            video.currentTime = 0;
            video.play().catch(function () {
                // Handle any play errors silently
            });
        }
    };
    DualBalance.prototype.loopVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            this.clearVideoTimeout();
            video.loop = true;
            video.play().catch(function () {
                // Handle any play errors silently
            });
        }
    };
    DualBalance.prototype.resetVideo = function () {
        var video = this.$refs.buyButtonVideo;
        if (video) {
            video.loop = false;
        }
        this.startVideoInterval();
    };
    DualBalance.prototype.setActiveCurrency = function (currency) {
        if (this.activeCurrency !== currency) {
            this.isTooltipOpen = false;
        }
        else {
            this.isTooltipOpen = !this.isTooltipOpen;
        }
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], DualBalance.prototype, "delay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DualBalance.prototype, "gameplay", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DualBalance.prototype, "fullscreen", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.ANIMATE_COIN_SHOP_BUTTON,
        }),
        __metadata("design:type", Object)
    ], DualBalance.prototype, "animateCoinShopButton", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SWEEPCOINS_ANIMATION_TRANSITION,
        }),
        __metadata("design:type", Object)
    ], DualBalance.prototype, "hasAnimations", void 0);
    __decorate([
        Watch('delay'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], DualBalance.prototype, "delayChanged", null);
    DualBalance = __decorate([
        Component({
            name: 'corex-dual-balance',
        })
    ], DualBalance);
    return DualBalance;
}(Mixins(MagicConfigMixin, BalanceMixin)));

export default DualBalance;
export { LAST_USED_CURRENCY };
